"use client"

import { Rabbit } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `RabbitIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const RabbitIcon = component(Icon)({ as: Rabbit })
